import styled, { css } from 'styled-components';
import { Modal as AntdModal } from 'antd';

type TitleProps = {
  variant: 'primary' | 'secondary';
};

export const Modal = styled(AntdModal)`
  ${({ theme }) => css`
    .ant-modal-content {
      border: 1px solid ${theme.colors.neutralSilver10};
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.05);
      border-radius: 16px;
    }

    .ant-modal-body {
      padding: 16px 32px 0;

      display: flex;
      align-items: center;
      justify-content: space-between;

      @media (max-width: 500px) {
        padding: 16px 16px 0;
      }

      @media (max-width: 405px) {
        flex-wrap: wrap;
      }
    }

    .ant-modal-close-x {
      width: 48px;
      height: 48px;
    }
  `}
`;

const titleModifiers = {
  primary: css`
    font-size: 3.6rem;
    line-height: 4.3rem;
  `,
  secondary: css`
    font-size: 3.2rem;
    line-height: 3.8rem;
  `,
};

export const Title = styled.p<TitleProps>`
  ${({ theme, variant }) => css`
    font-weight: 600;

    color: ${theme.colors.neutralSilver80};

    span {
      color: ${theme.colors.statusSuccess30};
    }

    margin-bottom: 12px;

    ${titleModifiers[variant]}

    @media (max-width: 768px) {
      font-size: 3.2rem;
      line-height: 3.8rem;
    }
  `}
`;

export const ModalContent = styled.div`
  padding-bottom: 16px;
`;

export const Image = styled.img`
  align-self: flex-end;
  object-fit: contain;

  width: 100%;
  height: 100%;
  max-width: 238px;
  max-height: 226px;

  @media (max-width: 500px) {
    max-width: 138px;
    max-height: 160px;
  }

  @media (max-width: 405px) {
    max-width: 100%;
  }
`;
